import { memo, useState } from 'react';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import { renderInlineCssVars, useDesignTokens } from '../../../theme';
import { postfixTestId } from '../../../util/testId';
import { Button, ButtonVariant } from '../../Button';
import { Heading } from '../../Heading';
import { Flow } from '../../Layouts/Flow';
import { MessageDialog, useMessageDialogText } from '../../MessageDialog';
import { useSettingsReset } from '../store/SettingsStore';
import bundle from '../NovaComponents-Settings-gui-icu.properties';
import cn from './FormGroupNavigation.css.json';
import './FormGroupNavigation.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useTextLocalizer = createUseTextLocalizer(bundle);
/**
 * HOC used to create a connected Form to be set upon
 * to the FormGroup model object for Settings component.
 */
export function connectToPreferenceStore(Form, dependentPreferenceKeys, hideReset = false) {
  const MemoizedForm = /*#__PURE__*/memo(Form);
  const FormGroupWrapper = ({
    heading,
    id,
    ...testIdProps
  }) => {
    const [isResetDialogOpen, setResetDialogOpen] = useState(false);
    const localize = useTextLocalizer();
    const {
      RESET,
      CANCEL
    } = useMessageDialogText();
    const [isResetButtonEnabled, reset] = useSettingsReset(dependentPreferenceKeys);
    const dt = useDesignTokens();
    const tokens = renderInlineCssVars({
      'font-weight-thick': dt.tokens['font-style-weight-700']
    }, 'form-group-navigation');
    return /*#__PURE__*/_jsxs(Flow, {
      orientation: "vertical",
      style: tokens,
      className: cn.container,
      children: [/*#__PURE__*/_jsxs("header", {
        className: cn.header,
        children: [/*#__PURE__*/_jsx(Heading, {
          level: 5,
          wrapText: false,
          className: cn.headerTitle,
          id: `${id}-header`,
          children: heading
        }), !hideReset && /*#__PURE__*/_jsx(Button, {
          testId: postfixTestId(testIdProps.testId, 'resetButton'),
          text: localize('settings.reset.button.label'),
          className: cn.resetButton,
          variant: ButtonVariant.LightSmall,
          disabled: !isResetButtonEnabled,
          onPress: () => setResetDialogOpen(true)
        })]
      }), /*#__PURE__*/_jsx("section", {
        className: cn.content,
        tabIndex: -1,
        children: /*#__PURE__*/_jsx(MemoizedForm, {})
      }), /*#__PURE__*/_jsx(MessageDialog, {
        testId: "settings-resetAction",
        type: "warning",
        isOpen: isResetDialogOpen,
        title: localize('settings.reset.dialog.title'),
        text: localize('settings.reset.warning.msg'),
        firstAction: {
          text: RESET,
          onPress: () => {
            setResetDialogOpen(false);
            reset();
          }
        },
        dismissAction: {
          text: CANCEL,
          onPress: () => setResetDialogOpen(false),
          isDefault: true
        }
      })]
    });
  };
  FormGroupWrapper.displayName = `FormGroupWrapper(${Form.name})`;
  return FormGroupWrapper;
}
//# sourceMappingURL=connect.js.map